module.exports = __webpack_public_path__ + "img/tuto_internet_way_02_08.41b4c6aa.png";